import { Capacitor } from '@capacitor/core'
import { StatusBar, Style } from '@capacitor/status-bar'

function measureEnvSafeAreaTop(): number {
  const probe = document.createElement('div')
  probe.style.cssText = [
    'position:fixed',
    'top:0',
    'left:0',
    'visibility:hidden',
    'pointer-events:none',
    'padding-top:constant(safe-area-inset-top)',
    'padding-top:env(safe-area-inset-top)',
  ].join(';')

  document.documentElement.appendChild(probe)
  const top = parseFloat(getComputedStyle(probe).paddingTop) || 0
  document.documentElement.removeChild(probe)
  return top
}

function resolveIosSafeAreaTop(): number {
  const fromEnv = measureEnvSafeAreaTop()
  if (fromEnv > 0) {
    return fromEnv
  }

  const fromViewport = window.visualViewport?.offsetTop ?? 0
  if (fromViewport > 0) {
    return fromViewport
  }

  // WKWebView can report 0 for env() on notched / Dynamic Island phones
  if (window.screen.height >= 812) {
    return 59
  }

  return 0
}

function applySafeAreaTop(): void {
  const top = resolveIosSafeAreaTop()
  const topPx = `${top}px`
  document.documentElement.style.setProperty('--safe-area-top', topPx)
  // Ionic toast (and other overlays) use --ion-safe-area-top for top offset.
  // Without this, top toasts sit under the Dynamic Island / status bar.
  document.documentElement.style.setProperty('--ion-safe-area-top', topPx)
}

export async function initNativeSafeArea(): Promise<void> {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'ios') {
    return
  }

  if (Capacitor.isPluginAvailable('StatusBar')) {
    await StatusBar.setOverlaysWebView({ overlay: true })
    await StatusBar.setStyle({ style: Style.Default })
  }

  applySafeAreaTop()
  window.addEventListener('resize', applySafeAreaTop)
  window.visualViewport?.addEventListener('resize', applySafeAreaTop)
}
